import { render, staticRenderFns } from "./RelacaoProjetoFiltro.vue?vue&type=template&id=383a882a"
import script from "./RelacaoProjetoFiltro.vue?vue&type=script&lang=js"
export * from "./RelacaoProjetoFiltro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports